import React from 'react';

import ColorItem from 'components/experiment/ui/ColorItem.component';
import createNodeKey from 'utils/react/createNodeKey.util';
import C from 'utils/values/constant.util';

import CN from './UiPage.module.scss';

const SYSTEM_COLORS = C([
  { hex: '#fff', variableName: '$c-grayscale-white' },
  { hex: '#f6f6f6', variableName: '$c-grayscale-lightest' },
  { hex: '#e8e8e8', variableName: '$c-grayscale-lighter' },
  { hex: '#d1d1d1', variableName: '$c-grayscale-light' },
  { hex: '#979797', variableName: '$c-grayscale-medium' },
  { hex: '#4a4a4a', variableName: '$c-grayscale-dark' },
  { hex: '#252629', variableName: '$c-grayscale-darker' },
  { hex: '#192340', variableName: '$c-grayscale-default' },
  { hex: '#f6e5fe', variableName: '$c-primary-lightest' },
  { hex: '#e3bff5', variableName: '$c-primary-light' },
  { hex: '#af6dd1', variableName: '$c-primary-medium' },
  { hex: '#821bb8', variableName: '$c-primary-default' },
  { hex: '#5f1486', variableName: '$c-primary-dark' },
  { hex: '#3e0b6c', variableName: '$c-primary-darker' },
  { hex: '#2a064b', variableName: '$c-primary-darkest' },
  { hex: '#d9e5ff', variableName: '$c-information-lightest' },
  { hex: '#b9cfff', variableName: '$c-information-light' },
  { hex: '#5c8fff', variableName: '$c-information-medium' },
  { hex: '#004fff', variableName: '$c-information-default' },
  { hex: '#003aba', variableName: '$c-information-dark' },
  { hex: '#002474', variableName: '$c-information-dark-2' },
  { hex: '#001441', variableName: '$c-information-darkest' },
  { hex: '#ffe2e2', variableName: '$c-error-lightest' },
  { hex: '#ffb3b3', variableName: '$c-error-light' },
  { hex: '#ff7b7b', variableName: '$c-error-medium' },
  { hex: '#f00', variableName: '$c-error-default' },
  { hex: '#e50000', variableName: '$c-error-dark' },
  { hex: '#b00', variableName: '$c-error-darker' },
  { hex: '#d4f7ee', variableName: '$c-success-lightest' },
  { hex: '#92ecd5', variableName: '$c-success-light' },
  { hex: '#54ddb4', variableName: '$c-success-medium' },
  { hex: '#05cf93', variableName: '$c-success-default' },
  { hex: '#10a478', variableName: '$c-success-dark' },
  { hex: '#146049', variableName: '$c-success-darker' },
  { hex: '#0b3025', variableName: '$c-success-darkest' },
  { hex: '#fff3ca', variableName: '$c-warning-lightest' },
  { hex: '#ffecab', variableName: '$c-warning-light' },
  { hex: '#ffca2d', variableName: '$c-warning-default' },
  { hex: '#e8b51f', variableName: '$c-warning-medium' },
  { hex: '#c69400', variableName: '$c-warning-dark' },
]);

const SERVICE_COLORS = C([
  { hex: '#3da49d', variableName: '$c-turquoise' },
  { hex: '#304e8c', variableName: '$c-blue-dark' },
  { hex: '#e55a6c', variableName: '$c-coral' },
  { hex: '#c93c7e', variableName: '$c-pink' },
  { hex: '#5e73d1', variableName: '$c-blue' },
  { hex: '#753a97', variableName: '$c-violet' },
  { hex: '#b82493', variableName: '$c-pink-medium' },
  { hex: '#e06490', variableName: '$c-pink-light' },
  { hex: '#7300af', variableName: '$c-purple' },
  { hex: '#9f5fc0', variableName: '$c-violet-light' },
  { hex: '#4e2082', variableName: '$c-purple-dark' },
  { hex: '#9e034c', variableName: '$c-pink-dark' },
  { hex: '#3b2a4c', variableName: '$c-purple-darker' },
  { hex: '#e06900', variableName: '$c-orange' },
  { hex: '#c54629', variableName: '$c-orange-dark' },
  { hex: '#426175', variableName: '$c-teal-dark' },
  { hex: '#007ba0', variableName: '$c-teal' },
  { hex: '#3a8463', variableName: '$c-green-dark' },
  { hex: '#4cac6a', variableName: '$c-green' },
  { hex: '#d29700', variableName: '$c-mustard' },
]);

const ColorsPanel = () => (
  <div data-bem="ColorsPanel" className={CN.container}>
    <h4>SYSTEM_COLORS</h4>
    <div className={CN.horizontalFlex}>
      {SYSTEM_COLORS.map(({ hex, variableName }, index) => (
        <ColorItem key={createNodeKey({ tag: hex, index })} index={index} variableName={variableName} hex={hex} />
      ))}
    </div>
    <h4>SERVICE_COLORS</h4>
    <div className={CN.horizontalFlex}>
      {SERVICE_COLORS.map(({ hex, variableName }, index) => (
        <ColorItem key={createNodeKey({ tag: hex, index })} index={index} variableName={variableName} hex={hex} />
      ))}
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default ColorsPanel;
